import { HeroSeoCotizador } from "../Landings/Components/HeroSeoCotizador";
import { PorQueElegirnos } from "../Landings/Components/PorQueElegirnos";
import { ComoFuncionaElCotizador } from "../Landings/Components/ComoFuncionaElCotizador";
import { QueCubreEsteSeguro } from "../Landings/Components/QueCubreEsteSeguro";
import { CompaniasSlider } from "../Landings/Components/CompaniasSlider";
import { PreguntasFrecuentes } from "../Landings/Components/PreguntasFrecuentes";
import { CtaCierreCotizador } from "../Landings/Components/CtaCierreCotizador";
import { imagesCompanias } from "../../Assets/imageCompania";
import heroSeoAuto from "../../Assets/img/heroSeoAuto.svg";
import "../Landings/Components/seoCotizador.css";

interface Props {
    visible: boolean;
}

const ASEGURADORAS_AUTO_AR = [
    "Galicia Seguros",
    "SMG Seguros",
    "Allianz",
    "Experta",
    "San Cristóbal",
    "Mercantil Andina",
    "Rivadavia",
    "Provincia Seguros",
    "Sancor Seguros",
    "Zurich",
    "Mapfre",
    "Meridional",
];

const listaAseguradoras = () => new Intl.ListFormat("es", { style: "long", type: "conjunction" }).format(ASEGURADORAS_AUTO_AR);

const companiasParaSlider = imagesCompanias.filter(
    (compania) => compania.pais?.includes("AR")
);

const scrollAlCotizador = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

export const SeoContenido = ({ visible }: Props) => {
    if (!visible) {
        return null;
    }

    return (
        <div className="seo-cotizador-scope">
            <HeroSeoCotizador
                h1="Cotizador de seguro de auto online: compará y contratá en minutos"
                bajada="Ingresá tu patente y recibí cotizaciones de las principales aseguradoras del país para elegir la cobertura que mejor se adapta a tu auto y tu bolsillo."
                parrafos={[
                    "Cotizar un seguro de auto no debería tomarte más de cinco minutos, y en Segurarse lo hacemos posible. Nuestro cotizador de seguro de auto compara en simultáneo los precios y coberturas de las aseguradoras líderes de Argentina, para que veas todas las opciones ordenadas en una sola pantalla y elijas con información real, no con suposiciones.",
                    "Con solo ingresar la patente o los datos del vehículo accedés a cotizaciones personalizadas según tu perfil, tu zona y el uso que le das al auto. Podés comparar coberturas de Responsabilidad Civil, Terceros Totales, Terceros Completo y Todo Riesgo, revisar franquicias, límites de suma asegurada y servicios adicionales, todo antes de decidir.",
                    "Sabemos que el precio del seguro del auto varía según la aseguradora, el modelo, la antigüedad y hasta el barrio donde vivís. Por eso comparar es la forma más simple de ahorrar sin resignar cobertura. Elegí la opción que más te convenga y contratá tu seguro al instante, sin trámites adicionales.",
                ]}
                ctaTexto="Cotizar mi seguro ahora"
                onCtaClick={scrollAlCotizador}
                imagenSrc={heroSeoAuto}
            />
            <PorQueElegirnos
                titulo="Por qué cotizar acá"
                bullets={[
                    "Cotizás 100% online y gratis.",
                    `Comparás en tiempo real precios y coberturas de ${listaAseguradoras()}.`,
                    "Contás con asesoramiento humano post-cotización: un especialista te ayuda a elegir la cobertura justa para tu auto.",
                    "Emitís tu póliza online, sin trámites presenciales.",
                    "Gestionás tus pólizas y siniestros online, las 24 horas, desde Mi Segurarse.",
                ]}
                mostrarImagen={false}
                anchoCompleto={true}
            />
            <ComoFuncionaElCotizador
                pasos={[
                    { numero: "1", texto: "Ingresá la patente de tu auto o los datos de tu auto." },
                    { numero: "2", texto: "Confirmá los datos del vehículo y luego pones tus datos personales." },
                    { numero: "3", texto: "En minutos comparás las cotizaciones de todas las aseguradoras disponibles para tu perfil, y elegís la que más te conviene." },
                ]}
            />
            <QueCubreEsteSeguro
                texto="El seguro de auto en Argentina se ofrece en cuatro grandes coberturas: Responsabilidad Civil (la mínima obligatoria, cubre daños a terceros), Terceros Totales (suma robo total y incendio total), Terceros Completo (suma robo parcial, incendio parcial y, dependiendo del tipo, granizo, parabrisas, cerraduras y cristales laterales) y Todo Riesgo (cubre también daños parciales al propio vehículo por choque). El cotizador te muestra qué incluye cada opción y su franquicia para que contrates la que más te sirva."
            />
            <div className="seo-cotizador-section">
                <div className="container">
                    <h2 className="seo-cotizador-h2">
                        Aseguradoras
                    </h2>
                    <p className="seo-cotizador-texto-bloque">
                        {`Trabajamos como bróker con las aseguradoras más importantes del mercado argentino: ${listaAseguradoras()}. Esto nos permite mostrarte cotizaciones reales y actualizadas.`}
                    </p>
                    <CompaniasSlider companias={companiasParaSlider} />
                </div>
            </div>
            <PreguntasFrecuentes
                tituloClassName="seo-cotizador-h2"
                faqs={[
                    {
                        titulo: "¿Cómo funciona el cotizador de seguros para autos?",
                        subTitulo: "Ingresás la patente o los datos de tu auto, confirmás tus datos personales y en minutos comparás las cotizaciones de todas las aseguradoras disponibles para elegir la que más te conviene.",
                    },
                    {
                        titulo: "¿Es gratis cotizar un seguro para auto?",
                        subTitulo: "Sí, cotizar con Segurarse no tiene costo ni obligación de contratar. Podés comparar todas las veces que quieras.",
                    },
                    {
                        titulo: "¿Qué información necesito para cotizar?",
                        subTitulo: "Con la patente alcanza para traer la mayoría de los datos del vehículo. Si es 0 km o todavía no lo patentaste, podés cotizar con marca, modelo y versión.",
                    },
                    {
                        titulo: "¿Cuánto tarda una cotización?",
                        subTitulo: "No debería tomarte más de cinco minutos: completás los datos del auto y tus datos personales, y recibís las cotizaciones al instante.",
                    },
                    {
                        titulo: "¿Qué compañías participan en el cotizador?",
                        subTitulo: `Trabajamos con las aseguradoras más importantes del mercado argentino, entre ellas ${listaAseguradoras()}.`,
                    },
                    {
                        titulo: "¿Puedo comparar precios entre distintas aseguradoras?",
                        subTitulo: "Sí, el cotizador te muestra en simultáneo el precio y la cobertura de cada aseguradora disponible para tu perfil, ordenadas en una sola pantalla.",
                    },
                    {
                        titulo: "¿Qué tipos de cobertura puedo cotizar?",
                        subTitulo: "Podés comparar Responsabilidad Civil, Terceros Totales, Terceros Completo y Todo Riesgo. En minutos ves qué incluye cada una antes de contratar.",
                    },
                    {
                        titulo: "¿Puedo contratar el seguro completamente online?",
                        subTitulo: "Sí, una vez que elegís la cobertura podés emitir la póliza online y recibirla por email en minutos.",
                    },
                    {
                        titulo: "¿Por qué usar el cotizador de Segurarse?",
                        subTitulo: "Es 100% online y gratuito, compara aseguradoras líderes en tiempo real, incluye asesoramiento humano post-cotización y te permite emitir la póliza y gestionar siniestros sin trámites presenciales.",
                    },
                ]}
            />
            <CtaCierreCotizador
                texto="Cotizá tu seguro de auto ahora y compará gratis todas las opciones del mercado."
                onClick={scrollAlCotizador}
            />
        </div>
    );
};
